export enum TypeOfSystemMessage {
  MessageOff = 'MessageOff',
  Information = 'Information',
  Warning = 'Warning',
  Critical = 'Critical'
}
